// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"215d5ec4f06fab3ca27f","966":"92560d6d5d8902e06920"}[chunkId] + ".js";
};